<template>
  <div :class="$style.Container">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      :disabled="props.disabled"
      :class="[$style.Tab, tab.value === props.active ? $style.TabActive : null]"
      @click="handleActive(tab.value)"
    >
      {{ tab.title }}
    </button>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { POD_PAYMENT_TAB } from '../../constants';

  const props = defineProps<{
    active: POD_PAYMENT_TAB;
    disabled?: boolean;
  }>();

  const tabs = ref([
    {
      title: '灵豆套餐',
      value: POD_PAYMENT_TAB.LINGDOU,
    },
    {
      title: '存储扩容',
      value: POD_PAYMENT_TAB.STORAGE,
    },
  ]);

  const emits = defineEmits(['update:active']);

  function handleActive(value: POD_PAYMENT_TAB) {
    if (value === props.active) {
      return;
    }

    emits('update:active', value);
  }
</script>

<style lang="less" module>
  .Container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 3px;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(66, 66, 66, 1);
    border-radius: 20px;
  }

  .Tab {
    flex: 1;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 16px;
    background: transparent;
    color: rgba(255, 255, 255, 0.65);
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }

  .TabActive {
    background-color: rgba(78, 78, 78, 1);
    color: rgba(255, 255, 255, 0.85);
  }
</style>
